import PropTypes from "prop-types";

export const PageModalNavigationItemAttributes = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export const PageModalNavigationItemType = PropTypes.shape(
  PageModalNavigationItemAttributes
);
